export default "__VITE_ASSET__2f26bed2__"